export default __webpack_public_path__ + "static/media/website.f7407a05.jpg";